export const TrophyType = Object.freeze({
    PLATINUM: 'platinum',      // platine
    GOLD: 'gold',              // or
    SILVER: 'silver',          // argent
    BRONZE: 'bronze',          // bronze
});
